import styled, { css } from "styled-components";
import { Colors } from '../../../../../values/colors';
import CalendarIcon from '../../../../../assets/icons/calendar_icon.svg';

export const Container = styled.div`
  ${({ isVisible }) => !isVisible && css`
    display: none;
  `};
  padding-left: 25px;
  padding-right: 25px;
  padding-top: 22px;
  pointer-events: ${(props) => !props.isEnabled && "none"};
`;

export const Line = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ConfigTitle = styled.p`
  font-family: 'Nunito Sans', sans-serif;
  color: ${Colors.blueMist};
  font-size: 14px;
  font-weight: 400;
  line-height: 10.98px;
  margin-bottom: 8px;
`;

export const Description = styled.p`
  font-family: 'Nunito Sans', sans-serif;
  color: ${Colors.blueMist};
  font-size: 13px;
  font-weight: 400;
  line-height: 20.48px;
  margin-top: 27px;
  margin-bottom: 22px;
`;

export const Error = styled.p`
  font-family: 'Nunito Sans', sans-serif;
  color: ${Colors.red};
  font-size: 13px;
  font-weight: 400;
  line-height: 20.48px;
`;

export const Input = styled.input.attrs({ type: 'date' })`
  color: ${Colors.blueMist};
  padding: 8px;
  border-radius: 4px;
  width: 280px;

  ::-webkit-calendar-picker-indicator {
    -webkit-appearance: none;
    appearance: none;
    background: url(${CalendarIcon}) no-repeat;
    
    background-size: contain; 
    width: 15px;
    height: 15px;
    cursor: pointer;
  }
`;